// src/components/Modals/ConfirmDeleteModal/ConfirmDeleteModal.jsx
"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./ConfirmDeleteModal.css";
import { useTranslation } from "react-i18next";

export default function ConfirmDeleteModal({
  open,
  title,
  confirmLabel,
  loading = false,
  onConfirm,
  onClose,
}) {
  const { t } = useTranslation();

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);

    // lock scroll
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="cdm-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cdm-title"
    >
      <div className="cdm-modal">
        <button
          className="cdm-close"
          aria-label={t("questions.deleteModal.close")}
          onClick={onClose}
        >
          ×
        </button>

        <div className="cdm-icon" aria-hidden>
          <svg
            viewBox="0 0 24 24"
            width="28"
            height="28"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <path d="M4 7h16" />
            <path d="M6 7l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14" />
            <path d="M9 7V4h6v3" />
          </svg>
        </div>

        <h3 id="cdm-title" className="cdm-title">
          {title || t("questions.deleteModal.title")}
        </h3>

        <p className="cdm-msg">
          {t("questions.deleteModal.messageLine1")}
          <br />
          {t("questions.deleteModal.messageLine2")}
        </p>

        <button
          className="cdm-danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading
            ? t("questions.deleteModal.deleting")
            : confirmLabel || t("questions.deleteModal.confirm")}
        </button>
      </div>
    </div>
  );
}

ConfirmDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  confirmLabel: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};
